/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { nthChildIterator, pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMENTING EXPORT SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  commentingexportsection: {
    '& .collapsable': {
      '& .innerWrap': {
        padding: 0
      },
      '&.opened': {
        overflow: 'visible',
        '& .innerWrap': {
          padding: pxToEm(16)
        }
      }
    },
    '& .export': {
      fontFamily: '"Work Sans", sans-serif;',
      '& .header': {
          marginBottom: pxToEm(24),
          display: 'block',
          opacity: '0',
          animationName: 'fadeInUp',
          animationDuration: '.2s',
          animationFillMode: 'forwards',
          animationDelay: '.1s',
          '& h3':{
              fontSize: pxToEm(16),
              fontWeight: 'bold',
              marginBottom: pxToEm(8)
          },
          '& p':{
              fontSize: pxToEm(14),
              fontWeight: 'normal'
          }
      },
      '& .exportbox': {
          padding: `${pxToEm(16)} ${pxToEm(24)}`,
          marginBottom: pxToEm(8),
          minHeight: pxToEm(96),
          maxHeight: pxToEm(96),
          maxWidth: pxToEm(898),
          opacity: '0',
          animationName: 'fadeInUp',
          animationDuration: '.2s',
          animationFillMode: 'forwards',
          extend: nthChildIterator(100, .2, .1),
          '& .exportdescription': {
              paddingLeft: pxToEm(24)
          },
          '& .title > .titletip': {
              paddingLeft: pxToEm(12)
          }
      }
    },
    [mediaQuery.thinnest]: {
        export: {
            '& .exportbox': {
                maxHeight: '100%'
            }
        }
    },
    '@global':{
        '.tippy-tooltip': {
            minWidth: pxToEm(520),
            display: 'flex',
            '& .csvToolTip': {
                padding: pxToEm(16),
                fontSize: pxToEm(14),
                fontWeight: '400',
                textAlign: 'left',
                minWidth: pxToEm(512),
                color: theme.color.supporting.medium.swatch,
            }
        }
    }
  }
});
